var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-zinc-900 mt-6",attrs:{"aria-labelledby":"footer-heading"}})
}
var staticRenderFns = []

export { render, staticRenderFns }